module.exports = __webpack_public_path__ + "img/home_modal_1.449a5b0c.png";